export class Banco {
    constructor(
        public readonly Id: number,
        public readonly Codigo: string | null,
        public readonly Nombre: string | null,
        public readonly PaisId: number | null,
        public readonly PaisNombre: string | null,
        public  Activo: boolean
    ) { }
}

export class SearchBancoRequest {
    constructor(
        public readonly PageSize: number | null,
        public readonly PageNumber: number | null,
        public readonly OrderAscending: boolean | null,
        public readonly OrderFieldName: string | null,
        public readonly Codigo: string | null,
        public readonly PaisId: number | null,
        public readonly Nombre: string | null,
        public readonly VerSoloActivos: boolean | null
    ) { }
}

export class SaveBancoDto {
    constructor(
        public readonly Codigo: string | null,
        public readonly Nombre: string | null,
        public readonly PaisId: number | null,
        public readonly PaisNombre: string | null,
        public readonly Activo: boolean
    ) { }
}

export class SearchBancoResponse {
    constructor(
      public readonly count: number,
      public readonly result: Banco[]
  ) { }
}